/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AsControllerGetVendorPendingCount$Params {
  clientWorkspaceId: string;
}

export function asControllerGetVendorPendingCount(http: HttpClient, rootUrl: string, params: AsControllerGetVendorPendingCount$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'count'?: number;
}>> {
  const rb = new RequestBuilder(rootUrl, asControllerGetVendorPendingCount.PATH, 'get');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'count'?: number;
      }>;
    })
  );
}

asControllerGetVendorPendingCount.PATH = '/api/v1/as/vendor/{clientWorkspaceId}/pending-count';
